const FormLabel = ({
  children,
  required = false,
  hint = "",
  className = "",

  size = "xs", // xs | sm | base
  uppercase = false,
  weight = "semibold", // normal | medium | semibold | bold
}) => {
  const sizeClasses = {
    xs: "text-xs",
    sm: "text-sm",
    base: "text-base",
  };

  const weightClasses = {
    normal: "font-normal",
    medium: "font-medium",
    semibold: "font-semibold",
    bold: "font-bold",
  };

  return (
    <div className="mb-1.5">
      <label
        className={`
          block
          ${sizeClasses[size]}
          ${weightClasses[weight]}
          ${uppercase ? "uppercase tracking-wide" : ""}
          text-slate-900 dark:text-slate-400
          mb-1
          ${className}
        `}
      >
        {children}

        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      {hint && <p className="text-[10px] text-slate-500 mt-0.5">{hint}</p>}
    </div>
  );
};

export default FormLabel;
